import { Component, OnInit } from '@angular/core';
import { CfdiApi } from 'src/shared/sdk/services';
import { ActivatedRoute } from '@angular/router';
import { Cfdi } from 'src/shared/sdk';
import { NgxXml2jsonService } from 'ngx-xml2json';

@Component({
  selector: 'app-pdf-html',
  templateUrl: './pdf-html.component.html',
  styleUrls: ['./pdf-html.component.scss']
})
export class PdfHtmlComponent implements OnInit {
  uuid;
  cfdi: Cfdi;
  xml;
  constructor(
    private route: ActivatedRoute,
    private cfdiApi: CfdiApi,
    private ngxXml2jsonService: NgxXml2jsonService
  ) {
    this.uuid = this.route.snapshot.paramMap.get("uuid");
  }

  ngOnInit() {
    this.cfdiApi.find({
      where: {
        "data.uuid": this.uuid
      }
    }).subscribe((cfdi: Cfdi[]) => {
      this.cfdi = cfdi[0];
      const parser = new DOMParser();
      const xml = parser.parseFromString(cfdi[0].data.cfdi, 'text/xml');
      this.xml = this.ngxXml2jsonService.xmlToJson(xml);
      if (!Array.isArray(this.xml['cfdi:Comprobante']['cfdi:Conceptos']['cfdi:Concepto'])) {
        this.xml['cfdi:Comprobante']['cfdi:Conceptos']['cfdi:Concepto'] = [this.xml['cfdi:Comprobante']['cfdi:Conceptos']['cfdi:Concepto']];
      }
    })
  }

}
